import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncomeInputNumberComponent } from './input-number.component';
import { FormsModule } from '@angular/forms';
import { NumberOnlyModule } from '../../../../../shared/directives';


@NgModule({
  declarations: [IncomeInputNumberComponent],
  imports: [
    CommonModule,
    FormsModule,
    NumberOnlyModule,
  ],
  exports: [
    IncomeInputNumberComponent
  ]
})
export class IncomeInputNumberModule { }
